import React from 'react';
import { HistoryItem, PricesTabType } from 'store/state/selectors/insights/prices';
import { SmallText } from 'ds/components/typography';
import { TableColumn } from 'ds/components/table';
import { useLocale } from 'locale';
import { ColumnRendererProps, EMPTY_COL_CHAR } from '../../../utils';
import { HistoryPricesColumn } from './styled';

export const getHistoryPricePerSqFtColumnConfig = (tabId: PricesTabType): Partial<TableColumn<HistoryItem>> => ({
  sortFn: (items: HistoryItem[]) => items.sort((a, b) => b.pricePerSqFt - a.pricePerSqFt),
  width: '15%',
  gap: 16,
  align: 'right',
});

export const HistoryPricePerSqFtColumn: React.FC<ColumnRendererProps<HistoryItem>> = ({ item }) => {
  const { formatMoney } = useLocale();
  return (
    <HistoryPricesColumn>
      <SmallText>{item.pricePerSqFt ? formatMoney(item.pricePerSqFt) : EMPTY_COL_CHAR}</SmallText>
    </HistoryPricesColumn>
  );
};
